<template>
  <vx-tooltip :text="date | momentFormat('DD.MM.YYYY HH:mm')">
    <span class="messenger-date">{{ date | messageDateAndTime }}</span>
  </vx-tooltip>
</template>

<script>
export default {
  props: {
    date: {
      type: Number,
      required: true
    }
  }
}
</script>
